module.exports = __webpack_public_path__ + "img/vivaldi-web-browser.8ae69139.png";